import { Message } from "../../../domain/model/Auth";
import { Store } from "../../../domain/model/Store";
import { Response } from "../../api/Response";
import NetworkApi from "../../network/NetworkApi";
import { StoreRepository } from "./StoreRepository";

export class StoreRepositoryImpl implements StoreRepository {
  apiService: NetworkApi;

  constructor(datasource: NetworkApi) {
    this.apiService = datasource;
  }
  createStore(store: Store): Promise<Response<Message>> {
    return this.apiService.createStore(store);
  }
  getStores(): Promise<Response<Array<Store>>> {
    return this.apiService.getStores();
  }
  getStore(id: string): Promise<Response<Store>> {
    return this.apiService.getStore(id);
  }
  updateStore(store: Store): Promise<Response<Message>> {
    return this.apiService.updateStore(store);
  }
  deleteStore(id: string): Promise<Response<Message>> {
    return this.apiService.deleteStore(id);
  }
}
